/*
 * beatsClock - Swatch Internet Time clock jQuery plugin
 * v1.0.1, 2009-09-12 - initial jQuery plugin
 * v2.0.0, 2020-11-20 - get rid of deprecated .selector
 * v2.0.1, 2021-03-01 - new license, new contact email
 * Paul Philippov, paul@themactep.com
 * Homepage: http://themactep.com/beats/jquery
 * License: WTFPL
 * Note: This plugin requires ppds.date.js library!
 */

(function ($) {
  $.fn.beatsClock = function () {
    if (!Date.prototype.toInternetTime) {
      console.log(".beats jQuery plugin requires ppds.date.js library");
      return false;
    }

    const element = this;
    const accuracy = parseInt(arguments[0]);

    tick = function () {
      element.html(new Date().toInternetTime(accuracy));
    }

    setInterval('tick()', 864);
    return this;
  };
})(jQuery);
